import { createUseStyles } from 'react-jss';
import { grayPalette } from '@tcl-argon-colors/colors';
import { LoaderProps } from './types';

export const useLoaderStyles = createUseStyles({
  root: {
    alignItems: 'center',
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    height: ({ scale }: LoaderProps) => `${Math.floor(35 * scale)}px`,
    justifyContent: 'center',
    overflow: 'hidden',
    transition: '0.8s background-color',
    width: ({ scale }: LoaderProps) => `${Math.floor(35 * scale)}px`,
  },
  spinner: {
    animation: 'rotateClockwise 1.2s linear infinite',
    border: `3px solid ${grayPalette.gray30}`,
    borderLeftColor: ({ color }: LoaderProps) => color,
  },
  checkSvg: {
    color: ({ color }: LoaderProps) => color,
    animation: 'pulse .3s ease-in-out .5s both',
    borderRadius: '50%',
    height: 'inherit',
    width: 'inherit',
  },
});
